import React, { useEffect, useState } from 'react'
import axiosClient from './api/axiosClient';

export default function ModalEditPassComment({ isOpen, onClose, dataPass, onSuccess }) {

    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState('');
    const [comment, setComment] = useState("");
    const [errors, setErrors] = useState({});

    // Mettre à jour les valeurs du formulaire avec les informations de la carte sélectionnée
    useEffect(() => {
        if (dataPass) {
            setComment(dataPass.comment || "");  // Assurez-vous de gérer les valeurs nulles
            setErrors("");  // Assurez-vous de gérer les valeurs nulles
        }
    }, [dataPass]);

    // Fonction de validation des champs
    const validateFields = () => {
        const validationErrors = {};
        const trimmedComment = comment.trim();

        if (!trimmedComment) {
            validationErrors.comment = 'Ce champ est requis.';
        } else {
            
        }

        return validationErrors;
    };

    // Fonction pour supprimer la carte
    const handleEditPassComment = (e) => {
        e.preventDefault();

        const validationErrors = validateFields();
        setErrors(validationErrors);

        // Si des erreurs existent, on arrête l'exécution
        if (Object.keys(validationErrors).length > 0) return;

        // Création des données de formulaire
        const formData = new FormData();
        formData.append('comment', comment);

        setLoading(true);
        // Logique pour sauvegarder les modifications (par exemple, appeler une API avec les nouvelles données)
        axiosClient.post(`/request/user/organizer/event-official/ticket/edit/passComment/pI/${dataPass.id}`, formData)
            .then(
                ({data}) => {
                    onSuccess(data.message);
                    setLoading(false);
                    onClose();

            }).catch(err => {
                const response = err.response;
                if (response) {
                    // console.log("Erreur de l'API :", response);
                    if (response.status === 422) {
                        setValidationError("Erreur ! Veuillez réessayer s'il vous plait !");
                    }else if (response.status === 500) {
                        // Erreur générale
                        setValidationError(response.data.errors);
                    }
                    setLoading(false);
                    setTimeout(() => setValidationError(""), 7000);
                } else {
                    setValidationError("Erreur lors de la sauvegarde du commentaire.");
                    setLoading(false);
                    setTimeout(() => setValidationError(""), 7000);
                }
            })
    };

    const isSubmitDisabled = () => {
        return loading || !comment;
    };

    return (
        isOpen && (
            <div className='inset-0 z-10 w-screen overflow-y-hidden fixed bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center' style={{
                zIndex: 100,
                top: 0,
                width: "100%",
                height: "100%",
                overflowX: "hidden",
                overflowY: "hidden",
                outline: 0,
                left: 0,
                margin: 0,
            }}>
                
                {validationError && (
                    <div className="text-sm fixed mt-4 top-0 z-10 cf8dr cb8zv cvkq6 clbq0 cuvgf">
                        <div className="flex cm3rx ce4zk c6btv">
                            <div className="flex">
                            <svg
                                className="cbm9w czr3n cq1qg coqgc chfzq"
                                width={16}
                                height={16}
                                viewBox="0 0 16 16"
                            >
                                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z" />
                            </svg>
                            <div>{validationError}</div>
                            </div>
                        </div>
                    </div>
                )}
                <div
                    className="flex items-center justify-center cxe43 cnbwt cini7 fixed cys4p py-4 clbq0"
                    role="dialog"
                    aria-modal="true">
                    <div className="bg-white rounded-lg w-96 flex cm4ey p-5">
                        
                        <div className='w-full'>
                            {/* Modal content */}
                            <div className="cbw8w">
                                <textarea
                                    id="comment"
                                    className="cn9r8 c071z w-full mb-4"
                                    style={{ backgroundColor: 'rgb(243 244 246 / 1)' }}
                                    rows={4}
                                    value={comment}
                                    placeholder={"Saisissez un commentaire ici"}
                                    onChange={(e) => setComment(e.target.value)}
                                    required
                                />
                                {errors.comment && (
                                    <small className="text-red-600 mt-2">
                                        {errors.comment}
                                    </small>
                                )}
                            </div>
                            {/* Modal footer */}
                            <div className="flex flex-wrap justify-end ch3kz">
                                <button onClick={onClose} className="border-gray-200 text-gray-800 cc0oq cghq3 cspbm c0zkc cnf4p">
                                    Annuler
                                </button>
                                <button onClick={handleEditPassComment} disabled={isSubmitDisabled()} className="text-white c8ham bg-primary-6000 cpcyu cnf4p hover:bg-primary-700">
                                    {loading ? (
                                        <>
                                            <svg
                                                className="animate-spin -ml-1 mr-3 h-5 w-5 ml-3"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx={12}
                                                    cy={12}
                                                    r={10}
                                                    stroke="currentColor"
                                                    strokeWidth={3}
                                                />
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                />
                                            </svg>
                                            Un instant...
                                        </>
                                        ) : (
                                        <>Sauvegarder</>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
    
            </div>
        )
    )
}
